import React, { useContext, useEffect, useReducer, useState } from "react";
import DashboardLayout from "../../../../layoutcontainers/DashboardLayout";
import {
  noticeperiodDaysOptions,
  noticePeriodOffer,
  resignationReasonOptions,
  resignationState,
  resignationStateMange,
} from "../residnationData";
import { useLocation, useNavigate } from "react-router-dom";
import { ButtonGroup, Card, CardContent, CardHeader, Stack } from "@mui/material";
import MaterialTypography from "../../../../components/MaterialTypography";
import { BsFillPersonVcardFill } from "react-icons/bs";
import MaterialBox from "../../../../components/MaterialBox";
import Grid from "@mui/material/Grid2";
import MaterialInput from "../../../../components/MaterialInput";
import MaterialSelect from "../../../../components/MasterSelect";
import MaterialButton from "../../../../components/MaterialButton";
import UserDetailsContext, { useUserDetails } from "../../../../context/auth";
import axios from "axios";
import BASEURL from "../../../Utils/Baseurl";
import { createMutationQuery, deleteResignationFormQuery, getResignationDataById, updateMutationQuery } from "../GraphQl";
import ConfirmationDialog from "../../../../components/Dialog/ConfirmationDialog";
import request from "graphql-request";
import DeleteIcon from "@mui/icons-material/Delete";
import EditIcon from "@mui/icons-material/Edit";
import Swal from "sweetalert2";

const ResignationForm = () => {
  const [resignationData, dispatch] = useReducer(
    resignationStateMange,
    resignationState
  );
  const userData = JSON.parse(sessionStorage.getItem("user"));
  const teamleaderID = (JSON.parse(sessionStorage.getItem("user"))).teamleader;
  const { AccessData} = useUserDetails(); 
  const navigate = useNavigate();
  const params = useLocation();
  const ID = params.search.slice(4);
  const { user } = useContext(UserDetailsContext);
  const today = new Date().toISOString().split("T")[0];

  const [inputDisble, setInputDisble] = useState(false);
  const [pageState, setPageState] = useState({
      loading: false,
      error: false,
      message: "",
      state: "init",
  });
  const [togglePage, setTogglePage] = useState({
      view: false,
      edit: false,
  });
  const [hrApproval,setHrApproval]= useState("");
  const [confirmationDialog, setConfirmationDialog] = useState({
    open: false,
    title: "",
    message: "",
    showCancel: true,
    showConfirm: true,
    customSection: null,
    onConfirm: () => {},
    onCancel: () => {},
  });

  useEffect(() => {
    dispatch({
      value: user?.first_name + " " + user?.last_name,
      name: "employeeName",
    });
    dispatch({
      value: user?.empid,
      name: "employeeId",
    });
    dispatch({
      value: user?.designation,
      name: "designation",
    });
    dispatch({
      value: user?.department,
      name: "department",
    });
    dispatch({
      value: user?.department,
      name: "department",
    });
    dispatch({
      value: today,
      name: "dateOfResignation",
    });
  }, [user]);

  useEffect(() => {
    if (ID) {
      fetchResignationDataById();
    }
  }, [ID]);

  //Fetch Data By Id
  const fetchResignationDataById = async() => {
    setTogglePage({
      view: true,
      edit: false,
    });
    try{
        const resp = await request(BASEURL,getResignationDataById, {
          id: ID
        })
        const data = resp.getResignationFormById;        
        setHrApproval(data?.hrApproval);        
        dispatch({
          value: data?.employeeName,
          name: "employeeName",
        });
        dispatch({
          value: data?.employeeId,
          name: "employeeId",
        });
        dispatch({
          value: data?.dateOfResignation,
          name: "dateOfResignation",
        });
        dispatch({
          value: data?.designation,
          name: "designation",
        });
        dispatch({
          value: data?.department,
          name: "department",
        });
        dispatch({
          value: { label :data?.reason, value:data?.reason},
          name: "reason",
        });
        dispatch({
          value: { label :data?.noticePeriod, value:data?.noticePeriod},
          name: "noticePeriod",
        });
        dispatch({
          value: { label :data?.noticeOption, value:data?.noticeOption},
          name: "noticeOption",
        });
        dispatch({
          value: data?.otherReason,
          name: "otherReason",
        });
        
    }
    catch(error){
      console.error("Couldn't fetch data",error)
    }
  }

  //Create Mutation Function
  const submitHandleResignation = async () => {
      try{
        const response = await axios({
          url: BASEURL,
          method: "POST",
          headers: {
            "Content-Type": "application/json",
          },
          data: JSON.stringify({
            query: createMutationQuery,
            variables: {
              input: {
              user: userData.id,
              employeeName: resignationData.employeeName,
              employeeId: resignationData.employeeId,
              designation: resignationData.designation,
              department: resignationData.department,
              dateOfResignation: resignationData.dateOfResignation,
              reason: resignationData.reason?.value,
              otherReason: resignationData.otherReason || "",
              noticeOption: resignationData.noticeOption?.value,
              noticePeriod: resignationData.noticePeriod?.value || "",
              screenName: "Exit Formalities",
              waiveNotice: false,
              doNotWaiveNotice: false,
              replacementRequired: false,
              rehireRequired: false,
              teamleaderId: teamleaderID,
            }
            },
          }),
        });
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
        const successStatus = response.data.data.createResignationForm?.success;
        const responseMessage = response.data.data.createResignationForm?.message;
        if(successStatus){
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Resignation Form Submitted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/resignation-list");
        }
        else{
          Swal.fire({
            position: "center",
            icon: "error",
            title: responseMessage,
            showConfirmButton: false,
            timer: 2500,
          });
        }
      }
      catch(error){
        console.error("Error Submitting Data: ",error)
      }
  }

  //Create Function
  const onAddResignation = () => { 
    
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Submit your Details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        submitHandleResignation();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Update Mutation Fucntion
  const updateHandleResignation = async () => {
    try{
      const response = await axios({
        url: BASEURL,
        method: "POST",
        headers: {
          "Content-Type": "application/json",
        },
        data: JSON.stringify({
          query: updateMutationQuery,
          variables: {
            input: {
            id: ID,
            user: userData.id,
            employeeName: resignationData.employeeName,
            employeeId: resignationData.employeeId,
            designation: resignationData.designation,
            department: resignationData.department,
            dateOfResignation: resignationData.dateOfResignation,
            reason: resignationData.reason?.value,
            otherReason: resignationData.otherReason || "",
            noticeOption: resignationData?.noticeOption?.value || "",
            noticePeriod: resignationData.noticePeriod?.value,
            waiveNotice: false,
            doNotWaiveNotice: false,
            replacementRequired: false,
            rehireRequired: false,
            teamleaderId: teamleaderID,
          }
          },
        }),
      });
      setConfirmationDialog({
        ...confirmationDialog,
        open: false,
      });
      Swal.fire({
        position: "center",
        icon: "success",
        title: "Resignation Form Updated Successfully!",
        showConfirmButton: false,
        timer: 2500,
      });
      navigate("/resignation-list");
    }
    catch(error){
      console.error("Error Submitting Data: ",error)
    }
  }

  //Update Function
  const onEditResignation = () => {
    setConfirmationDialog({
      open: true,
      title: "Confirmation",
      message: "Are you sure you want to Update your Details?",
      showCancel: true,
      showConfirm: true,
      onConfirm: () => {
        updateHandleResignation();
      },
      onCancel: () => {
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
      },
    });
  };

  //Delete Function
  const AddDelete = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure do you want to Delete your details.",
        showCancel: true,
        showConfirm: true,
        onConfirm: () => {
          onDeleteStaff();
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
  
  //Delete Mutation
  const onDeleteStaff = async () => {
  
      try {
        const response1 = await
          axios.post(
            BASEURL,
            {
              query: deleteResignationFormQuery,
              variables: {   id: ID,},
            },
            { headers: { "Content-Type": "application/json" } }
          )
        setConfirmationDialog({
          ...confirmationDialog,
          open: false,
        });
          Swal.fire({
            position: "center",
            icon: "success",
            title: "Resignation Form Deleted Successfully!",
            showConfirmButton: false,
            timer: 2500,
          });
          navigate("/resignation-list");
        
      } catch (error) {
        console.error("error:", error);
      }
  
  };

  //Cancel Function
  const handlecancel = () => {
      setConfirmationDialog({
        open: true,
        title: "Confirmation",
        message: "Are you sure you want to cancel?",
        showCancel: true,
        showConfirm: true,
        onConfirm: () => {
          onCancelAction();
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
        onCancel: () => {
          setConfirmationDialog({
            ...confirmationDialog,
            open: false,
          });
        },
      });
  };
   
  //Cancel Navigation Function
  const onCancelAction = ()=>{
    navigate('/resignation-list')
  }

  //Edit Page Toggle Function
  const toggleEdit = () => {
    setTogglePage({
      view: false,
      edit: true,
    });
  };

  return (
    
    <DashboardLayout>
      {confirmationDialog.open && (
      <ConfirmationDialog
        open={confirmationDialog.open}
        title={confirmationDialog.title}
        message={confirmationDialog.message}
        onConfirm={confirmationDialog.onConfirm}
        onCancel={confirmationDialog.onCancel}
        showCancel={confirmationDialog.showCancel}
        showConfirm={confirmationDialog.showConfirm}
      />
    )}
      <Card>
        <CardHeader
          title={
            <Stack
              direction="row"
              justifyContent="space-between"
              alignItems="center"
              spacing={2}
            >
              <Stack direction="column" spacing={0}>
                <MaterialTypography variant="h5" fontWeight="medium">
                  Resignation Details
                </MaterialTypography>
              </Stack>
              {  AccessData &&
        Array.isArray(AccessData) &&
        AccessData.some(
          (item) =>
            item.module === "Resignation" &&
            item.component === "EditResignation" &&
            item.can_access
        ) && togglePage.edit === true || togglePage.view === true && (
                  <ButtonGroup
                    variant="outlined"
                    aria-label="Loading button group"
                  >
                    {/* <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={toggleEdit}
                      startIcon={<EditIcon />}
                    >
                      Edit
                    </MaterialButton>
                    <MaterialButton
                      variant="gradient"
                      color="dark"
                      onClick={AddDelete}
                      startIcon={<DeleteIcon />}
                    >
                      Delete
                    </MaterialButton> */}
                  </ButtonGroup>
                )}
            </Stack>
          }
        />
        <CardContent sx={{ minHeight: "70vh" }}>
          <Stack
            direction="row"
            spacing={1}
            sx={{ display: "flex", alignItems: "center" }}
          >
            <BsFillPersonVcardFill style={{ fontSize: 20 }} />
            <MaterialTypography
              component="label"
              variant="body2"
              fontWeight="bold"
            >
              Employee Information
            </MaterialTypography>
          </Stack>
          <MaterialBox>
            <Grid container spacing={2}>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Name <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={resignationData?.employeeName}
                  name="employeeName"
                  placeholder="Enter Employee Name"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "employeeName" })
                  }
                  error={
                    resignationData.employeeNameStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    resignationData.employeeNameStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Employee Id <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={resignationData?.employeeId}
                  name="employeeId"
                  placeholder="Enter Employee Id"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "employeeId" })
                  }
                  error={
                    resignationData.employeeIdStatus === "error" ? true : false
                  }
                  success={
                    resignationData.employeeIdStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Date <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={resignationData?.dateOfResignation}
                  name="dateOfResignation"
                  placeholder="Enter Employee Id"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({
                      value: e?.target?.value,
                      name: "dateOfResignationStatus",
                    })
                  }
                  error={
                    resignationData.dateOfResignationStatus === "error"
                      ? true
                      : false
                  }
                  success={
                    resignationData.dateOfResignationStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Designation <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={resignationData?.designation}
                  name="designation"
                  placeholder="Enter Designation"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "designation" })
                  }
                  error={
                    resignationData.designationStatus === "error" ? true : false
                  }
                  success={
                    resignationData.designationStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Department <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialInput
                  value={resignationData?.department}
                  name="department"
                  placeholder="Enter Department"
                  disabled={true}
                  onChange={(e) =>
                    dispatch({ value: e?.target?.value, name: "department" })
                  }
                  error={
                    resignationData.departmentStatus === "error" ? true : false
                  }
                  success={
                    resignationData.departmentStatus === "success"
                      ? true
                      : false
                  }
                />
              </Grid>

              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Resignation Reason <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="reason"
                  value={resignationData?.reason}
                  customStyles={{ optionPadding: 20 }}
                  options={resignationReasonOptions?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: "reason" })}
                  error={
                    resignationData.reasonStatus === "error" ? true : false
                  }
                  success={
                    resignationData.reasonStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view}
                  // isLoading={productLoading}
                  isClearable
                />
              </Grid>
              {resignationData?.reason?.value?.toLowerCase() == "others" && (
                <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                    <MaterialTypography
                      component="label"
                      variant="caption"
                      fontWeight="bold"
                    >
                      Other Reason <span style={{ color: "red" }}>*</span>
                    </MaterialTypography>
                  </MaterialBox>
                  <MaterialInput
                    value={resignationData?.otherReason}
                    name="otherReason"
                    placeholder="Enter Department"
                    disabled={inputDisble || togglePage.view}
                    onChange={(e) =>
                      dispatch({ value: e?.target?.value, name: "otherReason" })
                    }
                    error={
                      resignationData.otherReasonStatus === "error"
                        ? true
                        : false
                    }
                    success={
                      resignationData.otherReasonStatus === "success"
                        ? true
                        : false
                    }
                  />
                </Grid>
              )}
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Notice Periods <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                </MaterialBox>
                <MaterialSelect
                  name="noticePeriod"
                  value={resignationData?.noticePeriod}
                  customStyles={{ optionPadding: 20 }}
                  options={noticePeriodOffer?.map((item) => {
                    return {
                      value: item,
                      label: item,
                    };
                  })}
                  onChange={(e, s) => dispatch({ value: e, name: "noticePeriod" })}

                  error={
                    resignationData.noticePeriodStatus === "error" ? true : false
                  }
                  success={
                    resignationData.noticePeriodStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view}
                />
              </Grid>
              {(hrApproval === "approved") &&(
              <Grid size={{ lg: 3, xs: 5, sm: 3 }}>
                  <MaterialBox lineHeight={0} display="inline-block">
                  <MaterialTypography
                    component="label"
                    variant="caption"
                    fontWeight="bold"
                  >
                    Notice Period Days <span style={{ color: "red" }}>*</span>
                  </MaterialTypography>
                  </MaterialBox>
                  <MaterialSelect
                  name="noticeOption"
                  value={resignationData?.noticeOption}
                  options={noticeperiodDaysOptions}
                  customStyles={{ optionPadding: 20 }}
                  onChange={(e, s) => dispatch({ value: e, name: "noticeOption" })}
                  error={
                    resignationData.noticeOptionStatus === "error" ? true : false
                  }
                  success={
                    resignationData.noticeOptionStatus === "success" ? true : false
                  }
                  isDisabled={togglePage.view}
                  />
              </Grid>
              )}
            </Grid>
          </MaterialBox>
          {togglePage.edit === true ? (
            <>
            <MaterialBox
              display="flex"
              justifyContent="flex-end"
              alignItems="center"
            >
               <MaterialButton
                   variant="gradient"
                   color="dark"
                   disabled={pageState.state === "submitting"}
                   onClick={handlecancel}
                 >
                   Discard
                 </MaterialButton>
                 <MaterialButton
                   sx={{ m: 2 }}
                   variant="gradient"
                   color="dark"

                   onClick={onEditResignation}
                 >
                   Update
                 </MaterialButton>
                 </MaterialBox>
            </>
            ) : togglePage.view === false && togglePage.edit === false ? (
            <>
          <MaterialBox
            display="flex"
            justifyContent="flex-end"
            alignItems="center"
          >
            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={handlecancel}
            >
              Cancel
            </MaterialButton>

            <MaterialButton
              sx={{ m: 2 }}
              variant="gradient"
              color="dark"
              onClick={onAddResignation}
            >
              Submit
            </MaterialButton>
          </MaterialBox>
          </>
               ) : null}
        </CardContent>
      </Card>
    </DashboardLayout>
  );
};

export default ResignationForm;
